import { docTypes } from './constants';
import { texts } from './languages/fr';

export const fundsOfOrigin = [
    { name: texts.VALEUR_MOBILIERE },
    { name: texts.VALEUR_IMMOBILIERE },
    { name: texts.VALEUR_LIQUIDITE },
    { name: texts.PRO_INCOME_SOURCES },
    { name: texts.AUTRE },
];

export const sourceOfFunds = [{ name: texts.FRANCE }, { name: texts.UE }, { name: texts.NON_UE }];

export const typeOfDocuments = [{ type: docTypes.OTHER, name: texts.AUTRES }];

export const activities = {
    agriculture: texts.ACTIVITE_AGRICOLE,
    industry: texts.ACTIVITE_INDUSTRIELLE,
    trade: texts.ACTIVITE_COMMERCIALE,
    holding: texts.ACTIVITE_HOLDING,
    other: texts.AUTRE,
};

export const situations = [
    { id: 1, name: 'Marié(e)' },
    { id: 2, name: 'Célibataire' },
    { id: 3, name: 'PACS' },
    { id: 4, name: 'Union libre' },
    { id: 5, name: 'Divorcé(e)' },
    { id: 6, name: 'Veuf(ve)' },
];

export const titles = ['Monsieur', 'Madame'];

export const positions = [
    'Gérant',
    'Co-gérant',
    'Président',
    'Directeur général',
    'Directeur financier',
    'Administrateur',
    'Secrétaire général',
    'Autre',
];

export const corporateForms = {
    SAS: 'SAS',
    SA: 'SA',
    SASU: 'SASU',
    SNC: 'SNC',
    SCP: 'SCP',
    SARL: 'SARL',
    EURL: 'EURL',
    EI: 'EI',
    SELARL: 'SELARL',
    SOCIETE_COMMODITE: 'Société en commandite',
    PARTNERSHIP: 'Partnership',
    LIMITED_PARTNERSHIP: 'Limited partnership',
    LLC: 'Limited liability company',
    CORPORATION: 'Corporation',
    TRUST: 'Trust',
    DEPOSIT: 'Deposit account',
    other: texts.AUTRE,
};

export const matrimonialRegimes = [
    { id: 0, name: texts.LEGAL_COMMUNITY },
    { id: 1, name: texts.PARTICIPATION_ACQUISITIONS },
    { id: 2, name: texts.UNIVERSAL_COMMUNITY },
    { id: 3, name: texts.PROPERTY_SEPARATION },
];

export const activitySectors = [
    { id: 4, name: texts.FINANCIAL_SERVICES },
    { id: 5, name: texts.ACTIVITE_HOLDING },
    { id: 2, name: texts.BANKS },
    { id: 3, name: texts.INSURANCE },
    { id: 15, name: texts.BUSINESS_MANAGEMENT },
    { id: 0, name: texts.AGROALIMENTAIRE },
    { id: 1, name: texts.ASSOCIATIONS },
    { id: 6, name: texts.CHEMISTRY },
    { id: 7, name: texts.TRADE },
    { id: 8, name: texts.COMMUNICATION },
    { id: 9, name: texts.CONSTRUCTION },
    { id: 10, name: texts.CULTURE },
    { id: 11, name: texts.ENERGY },
    { id: 12, name: texts.EDUCATION },
    { id: 13, name: texts.ENVIRONMENT },
    { id: 14, name: texts.GESTION },
    { id: 16, name: texts.REAL_ESTATE },
    { id: 17, name: texts.INDUSTRY },
    { id: 18, name: texts.INFORMATICS },
    { id: 19, name: texts.LOGISTICS },
    { id: 21, name: texts.LIBERAL_PROFESSIONS },
    { id: 22, name: texts.HEALTH },
    { id: 23, name: texts.SERVICES },
    { id: 20, name: texts.TRANSPORTATION },
    { id: 24, name: texts.AUTRE },
];

export const currencies = [
    'EUR',
    'USD',
    'GBP',
    'CHF',
    'CAD',
    'AUD',
    'DKK',
    'SEK',
    'AFN',
    'ZAR',
    'ALL',
    'DZD',
    'AOA',
    'XCD',
    'SAR',
    'ARS',
    'AMD',
    'AWG',
    'AZN',
    'BSD',
    'BHD',
    'BDT',
    'BBD',
    'BZD',
    'XOF',
    'BMD',
    'BTN',
    'INR',
    'BYR',
    'BOV',
    'BOB',
    'BAM',
    'BWP',
    'NOK',
    'BND',
    'BRL',
    'BGN',
    'BIF',
    'CVE',
    'KHR',
    'XAF',
    'KYD',
    'CLF',
    'CLP',
    'CNY',
    'COP',
    'KMF',
    'CDF',
    'NZD',
    'KRW',
    'KPW',
    'CRC',
    'HRK',
    'CUP',
    'ANG',
    'DJF',
    'EGP',
    'ERN',
    'ETB',
    'FKP',
    'FJD',
    'XDR',
    'GMD',
    'GEL',
    'GHS',
    'GIP',
    'GTQ',
    'GNF',
    'GYD',
    'HTG',
    'HNL',
    'HKD',
    'HUF',
    'IDR',
    'IRR',
    'IQD',
    'ISK',
    'ILS',
    'JMD',
    'JPY',
    'JOD',
    'KZT',
    'KES',
    'KGS',
    'KWD',
    'LAK',
    'SVC',
    'LSL',
    'LBP',
    'LRD',
    'LYD',
    'MOP',
    'MKD',
    'MGA',
    'MWK',
    'MYR',
    'MVR',
    'MUR',
    'MRO',
    'MXN',
    'MXV',
    'MDL',
    'MNT',
    'MAD',
    'MZN',
    'MMK',
    'NAD',
    'NIO',
    'NGN',
    'XPF',
    'NPR',
    'OMR',
    'UGX',
    'UZS',
    'PKR',
    'PAB',
    'PGK',
    'PYG',
    'XUA',
    'PEN',
    'PHP',
    'PLN',
    'QAR',
    'RON',
    'RUB',
    'RWF',
    'DOP',
    'CZK',
    'SHP',
    'WST',
    'STD',
    'RSD',
    'SCR',
    'SLL',
    'SGD',
    'XSU',
    'SBD',
    'SOS',
    'SDG',
    'SSP',
    'LKR',
    'CHE',
    'CHW',
    'SRD',
    'SZL',
    'SYP',
    'TJS',
    'TWD',
    'TZS',
    'THB',
    'TOP',
    'TTD',
    'TND',
    'TMT',
    'TRY',
    'UAH',
    'AED',
    'UYI',
    'UYU',
    'VUV',
    'VEF',
    'VND',
    'YER',
    'ZMW',
    'ZWL',
];

export const countries = [
    { name: 'France', id: 'FR' },
    { name: 'Afghanistan', id: 'AF' },
    { name: 'Afrique du Sud', id: 'ZA' },
    { name: 'Albanie', id: 'AL' },
    { name: 'Algérie', id: 'DZ' },
    { name: 'Allemagne', id: 'DE' },
    { name: 'Andorre', id: 'AD' },
    { name: 'Angola', id: 'AO' },
    { name: 'Antigua-et-Barbuda', id: 'AG' },
    { name: 'Arabie saoudite', id: 'SA' },
    { name: 'Argentine', id: 'AR' },
    { name: 'Arménie', id: 'AM' },
    { name: 'Australie', id: 'AU' },
    { name: 'Autriche', id: 'AT' },
    { name: 'Azerbaïdjan', id: 'AZ' },
    { name: 'Bahamas', id: 'BS' },
    { name: 'Bahreïn', id: 'BH' },
    { name: 'Bangladesh', id: 'BD' },
    { name: 'Barbade', id: 'BB' },
    { name: 'Biélorussie', id: 'BY' },
    { name: 'Belgique', id: 'BE' },
    { name: 'Belize', id: 'BZ' },
    { name: 'Bénin', id: 'BJ' },
    { name: 'Bhoutan', id: 'BT' },
    { name: 'Birmanie', id: 'MM' },
    { name: 'Bolivie', id: 'BO' },
    { name: 'Bosnie-Herzégovine', id: 'BA' },
    { name: 'Botswana', id: 'BW' },
    { name: 'Brésil', id: 'BR' },
    { name: 'Brunei', id: 'BN' },
    { name: 'Bulgarie', id: 'BG' },
    { name: 'Burkina Faso', id: 'BF' },
    { name: 'Burundi', id: 'BI' },
    { name: 'Cambodge', id: 'KH' },
    { name: 'Cameroun', id: 'CM' },
    { name: 'Canada', id: 'CA' },
    { name: 'Cap-Vert', id: 'CV' },
    { name: 'Chili', id: 'CL' },
    { name: 'Chine', id: 'CN' },
    { name: 'Chypre (pays)', id: 'CY' },
    { name: 'Colombie', id: 'CO' },
    { name: 'Comores (pays)', id: 'KM' },
    { name: 'Corée du Sud', id: 'KR' },
    { name: 'Corée du Nord', id: 'KP' },
    { name: 'Costa Rica', id: 'CR' },
    { name: "Côte d'Ivoire", id: 'CI' },
    { name: 'Croatie', id: 'HR' },
    { name: 'Cuba', id: 'CU' },
    { name: 'Danemark', id: 'DK' },
    { name: 'Djibouti', id: 'DJ' },
    { name: 'Dominique', id: 'DM' },
    { name: 'Égypte', id: 'EG' },
    { name: 'Émirats arabes unis', id: 'AE' },
    { name: 'Érythrée', id: 'ER' },
    { name: 'Eswatini', id: 'SZ' },
    { name: 'Équateur (pays)', id: 'EC' },
    { name: 'Espagne', id: 'ES' },
    { name: 'Estonie', id: 'EE' },
    { name: 'États fédérés de Micronésie (pays)', id: 'FM' },
    { name: 'États-Unis', id: 'US' },
    { name: 'Éthiopie', id: 'ET' },
    { name: 'Fidji', id: 'FJ' },
    { name: 'Finlande', id: 'FI' },
    { name: 'Gabon', id: 'GA' },
    { name: 'Gambie', id: 'GM' },
    { name: 'Géorgie (pays)', id: 'GE' },
    { name: 'Ghana', id: 'GH' },
    { name: 'Grèce', id: 'GR' },
    { name: 'Grenade (pays)', id: 'GD' },
    { name: 'Guatemala', id: 'GT' },
    { name: 'Guinée', id: 'GN' },
    { name: 'Guinée-Bissau', id: 'GW' },
    { name: 'Guinée équatoriale', id: 'GQ' },
    { name: 'Guyana', id: 'GY' },
    { name: 'Haïti', id: 'HT' },
    { name: 'Honduras', id: 'HN' },
    { name: 'Hongrie', id: 'HU' },
    { name: 'Inde', id: 'IN' },
    { name: 'Indonésie', id: 'ID' },
    { name: 'Iran', id: 'IR' },
    { name: 'Irak', id: 'IQ' },
    { name: 'Irlande (pays)', id: 'IE' },
    { name: 'Islande', id: 'IS' },
    { name: 'Israël', id: 'IL' },
    { name: 'Italie', id: 'IT' },
    { name: 'Îles Marshall (pays)', id: 'MH' },
    { name: 'Jamaïque', id: 'JM' },
    { name: 'Japon', id: 'JP' },
    { name: 'Jordanie', id: 'JO' },
    { name: 'Kazakhstan', id: 'KZ' },
    { name: 'Kenya', id: 'KE' },
    { name: 'Kirghizistan', id: 'KG' },
    { name: 'Kiribati', id: 'KI' },
    { name: 'Koweït', id: 'KW' },
    { name: 'Laos', id: 'LA' },
    { name: 'Lesotho', id: 'LS' },
    { name: 'Lettonie', id: 'LV' },
    { name: 'Liban', id: 'LB' },
    { name: 'Liberia', id: 'LR' },
    { name: 'Libye', id: 'LY' },
    { name: 'Liechtenstein', id: 'LI' },
    { name: 'Lituanie', id: 'LT' },
    { name: 'Luxembourg (pays)', id: 'LU' },
    { name: 'Macédoine du Nord', id: 'MK' },
    { name: 'Madagascar', id: 'MG' },
    { name: 'Malaisie', id: 'MY' },
    { name: 'Malawi', id: 'MW' },
    { name: 'Maldives', id: 'MV' },
    { name: 'Mali', id: 'ML' },
    { name: 'Malte', id: 'MT' },
    { name: 'Maroc', id: 'MA' },
    { name: 'Maurice (pays)', id: 'MU' },
    { name: 'Mauritanie', id: 'MR' },
    { name: 'Mexique', id: 'MX' },
    { name: 'Moldavie', id: 'MD' },
    { name: 'Monaco', id: 'MC' },
    { name: 'Mongolie', id: 'MN' },
    { name: 'Monténégro', id: 'ME' },
    { name: 'Mozambique', id: 'MZ' },
    { name: 'Namibie', id: 'NA' },
    { name: 'Nauru', id: 'NR' },
    { name: 'Népal', id: 'NP' },
    { name: 'Nicaragua', id: 'NI' },
    { name: 'Niger', id: 'NE' },
    { name: 'Nigeria', id: 'NG' },
    { name: 'Norvège', id: 'NO' },
    { name: 'Nouvelle-Zélande', id: 'NZ' },
    { name: 'Oman', id: 'OM' },
    { name: 'Ouganda', id: 'UG' },
    { name: 'Ouzbékistan', id: 'UZ' },
    { name: 'Pakistan', id: 'PK' },
    { name: 'Palaos', id: 'PW' },
    { name: 'Panama', id: 'PA' },
    { name: 'Papouasie-Nouvelle-Guinée', id: 'PG' },
    { name: 'Paraguay', id: 'PY' },
    { name: 'Pays-Bas', id: 'NL' },
    { name: 'Pérou', id: 'PE' },
    { name: 'Philippines', id: 'PH' },
    { name: 'Pologne', id: 'PL' },
    { name: 'Portugal', id: 'PT' },
    { name: 'Qatar', id: 'QA' },
    { name: 'République centrafricaine', id: 'CF' },
    { name: 'République démocratique du Congo', id: 'CD' },
    { name: 'République dominicaine', id: 'DO' },
    { name: 'République du Congo', id: 'CG' },
    { name: 'Roumanie', id: 'RO' },
    { name: 'Royaume-Uni', id: 'GB' },
    { name: 'Russie', id: 'RU' },
    { name: 'Rwanda', id: 'RW' },
    { name: 'Salvador', id: 'SV' },
    { name: 'Saint-Christophe-et-Niévès', id: 'KN' },
    { name: 'Saint-Marin', id: 'SM' },
    { name: 'Saint-Vincent-et-les-Grenadines', id: 'VC' },
    { name: 'Sainte-Lucie', id: 'LC' },
    { name: 'Salomon', id: 'SB' },
    { name: 'Samoa', id: 'WS' },
    { name: 'Sao Tomé-et-Principe', id: 'ST' },
    { name: 'Sénégal', id: 'SN' },
    { name: 'Serbie', id: 'RS' },
    { name: 'Seychelles', id: 'SC' },
    { name: 'Sierra Leone', id: 'SL' },
    { name: 'Singapour', id: 'SG' },
    { name: 'Slovaquie', id: 'SK' },
    { name: 'Slovénie', id: 'SI' },
    { name: 'Somalie', id: 'SO' },
    { name: 'Soudan', id: 'SD' },
    { name: 'Soudan du Sud', id: 'SS' },
    { name: 'Sri Lanka', id: 'LK' },
    { name: 'Suède', id: 'SE' },
    { name: 'Suisse', id: 'CH' },
    { name: 'Suriname', id: 'SR' },
    { name: 'Syrie', id: 'SY' },
    { name: 'Tadjikistan', id: 'TJ' },
    { name: 'Tanzanie', id: 'TZ' },
    { name: 'Tchad', id: 'TD' },
    { name: 'Tchéquie', id: 'CZ' },
    { name: 'Thaïlande', id: 'TH' },
    { name: 'Timor oriental', id: 'TL' },
    { name: 'Togo', id: 'TG' },
    { name: 'Tonga', id: 'TO' },
    { name: 'Trinité-et-Tobago', id: 'TT' },
    { name: 'Tunisie', id: 'TN' },
    { name: 'Turkménistan', id: 'TM' },
    { name: 'Turquie', id: 'TR' },
    { name: 'Tuvalu', id: 'TV' },
    { name: 'Ukraine', id: 'UA' },
    { name: 'Uruguay', id: 'UY' },
    { name: 'Vanuatu', id: 'VU' },
    { name: 'Venezuela', id: 'VE' },
    { name: 'Viêt Nam', id: 'VN' },
    { name: 'Yémen', id: 'YE' },
    { name: 'Zambie', id: 'ZM' },
    { name: 'Zimbabwe', id: 'ZW' },
];
